// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"594":"e7ad4b1e","766":"2c27ca61","960":"ab8b3ea8","970":"85ba6c77"}[chunkId] + ".chunk.js";
};